// Enums
import { EnvName } from '@enums/environment.enum';
import { LogLevel } from '@services/logger.service';
// Packages
import packageInfo from '../../package.json';

const scheme = 'https://';
const host = 'app.sensika.com';
const rootUrl = scheme + host;
const port = '';
const path = '/api/v1.0';

const baseUrl = scheme + host + port + path;
const baseUrlEnvironmentSuffix = '';

export const environment = {
  production: true,
  host: host,
  scheme: scheme,
  path: '',
  schemeWS: 'wss://',
  hostWS: host,
  portWS: ':443',
  pathWS: '/ws',
  logLevel: 'error' as LogLevel,
  version: packageInfo.version,
  appName: 'Sensika',
  envName: EnvName.PROD,
  defaultLanguage: 'en',
  baseUrl: rootUrl,
  baseUrlEnvironmentSuffix: baseUrlEnvironmentSuffix,
  apiBaseUrl: baseUrl,

  // new vars
  sensikaPath: '/',
  sensikaSysAppDomain: 'http://scm.sensika.com', // Used in HTML templates
  sensikaAdministrationUrl: 'https://scm.sensika.com/admin/',
  debugInfoEnabled: true,
  errorOnUnhandledRejections: true,

  sensikaFacebookLoginUrl: 'https://app.sensika.com/oauth/12/authorize',
  sensikaSamlLoginUrl: 'https://app.sensika.com/saml/2/authorize',
};
